module.exports = __webpack_public_path__ + "static/media/4.a2495a29.jpg";